module.exports = __webpack_public_path__ + "img/tr.45a810be.jpg";